import React, { useState } from "react";
import './RequestForm.css';

function Form() {
    // 1. Create state for form fields
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        product: "",
        details: ""
    });

    // 2. Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // 3. Validation and WhatsApp Redirect
    const handleSubmit = (e) => {
        e.preventDefault();

        const { firstName, lastName, email, phone, product, details } = formData;

        // Validation Logic
        if (!firstName.trim() || !lastName.trim()) {
            alert("Please enter both First and Last name.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert("Please enter a valid email address.");
            return;
        }

        // Check if phone is exactly 10 digits
        const phoneDigits = phone.replace(/\D/g, ""); // removes non-digits
        if (phoneDigits.length !== 10) {
            alert("Phone number must be exactly 10 digits.");
            return;
        }

        if (!product) {
            alert("Please select a Product Interest.");
            return;
        }

        // 4. Construct WhatsApp Message
        const whatsappNumber = "27726965644";
        const message = `*New Quote Request*%0A` +
            `*Name:* ${firstName} ${lastName}%0A` +
            `*Email:* ${email}%0A` +
            `*Phone:* ${phone}%0A` +
            `*Product:* ${product}%0A` +
            `*Details:* ${details}`;

        const url = `https://wa.me/${whatsappNumber}?text=${message}`;
        
        // Open WhatsApp
        window.open(url, "_blank");
    };

    return (
        <div className="Fpage">
            <div className="fdetails">
                <h3>Get Your Free Quote Today</h3>
                <p>
                    Ready to upgrade your property with premium aluminium solutions? 
                    Our expert team is standing by to provide you with a detailed, 
                    no-obligation quote tailored to your specific needs.
                </p>

                <ul>
                    <li>Free on-site consultation and measurement</li>
                    <li>Detailed quote within 24 hours</li>
                    <li>Expert advice on design and materials</li>
                    <li>Competitive pricing with transparent costs</li>
                </ul>

                <div className="contact">
                    <p>📞: +27 65 554 7428</p>
                    <p>📧: ipfieisrael@gmail.com</p>
                    <p>📍:Tshaulu, Thohoyandou</p>
                </div>
            </div>

            <form className="form" onSubmit={handleSubmit}>
                <h3>Request Your Quote</h3>

                <label>First Name</label>
                <input 
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Ipfi" 
                />

                <label>Last Name</label>
                <input 
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Ndou" 
                />

                <label>Email Address</label>
                <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="ipfieisrael@gmail.com" 
                />

                <label>Phone Number</label>
                <input 
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="0655547428" 
                />

                <label>Product Interest</label>
                <select name="product" value={formData.product} onChange={handleChange}>
                    <option value="">Option</option>
                    <option value="Windows">Windows</option>
                    <option value="Doors">Doors</option>
                    <option value="Gates">Gates</option>
                </select>

                <label>Project Details</label>
                <textarea 
                    name="details"
                    value={formData.details}
                    onChange={handleChange}
                    placeholder="Tell us about your project requirements..."
                ></textarea>

                <button type="submit" className="submit-btn">Submit →</button>
            </form>
        </div>
    );
}

export default Form;